// Cómo se llaman los archivos cuando alguien se baja un post —
// ADR-2026-09-16-bajar-las-piezas-de-un-post-y-copiar-su-copy.
//
// Las piezas se bajan SUELTAS, no en un ZIP: de un post se sacan para subirlas a
// otro lado, y descomprimir en el medio no aporta nada. Por eso el nombre importa
// más todavía — es lo único que las ordena en la carpeta de Descargas.
//
// Es la misma idea que el ZIP de carpetas (`exportarZip.ts`): el nombre tiene
// que seguir teniendo sentido cuando el archivo ya salió de acá y está suelto en
// la carpeta de Descargas entre otros cuarenta. Por eso lleva la fecha en la que
// el post sale, que es lo único que lo identifica sin abrir Atlas, y el número
// de orden, que es el del carrusel.
//
// Minúsculas y guiones bajos por el mismo motivo que allá: un archivo sobrevive
// a que lo arrastren a otro lado, lo suba un importador o lo manden por mail, y
// ahí los espacios y los acentos son un problema real.

/** Una pieza, en lo poco que hace falta para nombrarla. */
export interface PiezaParaBajar {
  fileName: string;
}

/** La extensión del original, o `jpg` si el nombre no dice nada. */
function extensionDe(fileName: string): string {
  const punto = fileName.lastIndexOf(".");
  const ext = punto >= 0 ? fileName.slice(punto + 1).toLowerCase() : "";
  return /^[a-z0-9]{1,5}$/.test(ext) ? ext : "jpg";
}

/**
 * `post_2026-09-20`, o `post` si todavía no tiene fecha.
 *
 * La fecha se arma por componentes locales y no con `toISOString`, que pasa a
 * UTC: un post de las 21:00 del 20 se bajaría llamándose del 21.
 */
export function nombreBaseDelPost(cuando: Date | null): string {
  if (!cuando) return "post";
  const p = (n: number) => String(n).padStart(2, "0");
  return `post_${cuando.getFullYear()}-${p(cuando.getMonth() + 1)}-${p(cuando.getDate())}`;
}

/** El nombre propuesto de cada pieza, en orden. La extensión final la corrige
 *  `descargarLote` por los BYTES, que es lo que hay que creerle. */
export function nombresDeLasPiezas(
  medios: readonly PiezaParaBajar[],
  cuando: Date | null,
): string[] {
  const base = nombreBaseDelPost(cuando);
  // Con una sola pieza no se numera: `post_2026-09-20.jpg` se lee mejor que
  // `post_2026-09-20_1.jpg` cuando no hay un 2.
  if (medios.length === 1) return [`${base}.${extensionDe(medios[0]!.fileName)}`];
  return medios.map((m, i) => `${base}_${i + 1}.${extensionDe(m.fileName)}`);
}
